import React, { useState } from 'react';
import YesNoDialog from '@/components/dialogs/YesNoDialog';
import { Button, ConfirmButtonProps } from '@/components/Buttons';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { Trans } from '@lingui/react/macro';

const ConfirmRemoveButton = React.forwardRef<HTMLElement, ConfirmButtonProps>(
    (
        {
            onConfirm,
            dialogTitle,
            dialogBody,
            dialogConfirmButtonColor = 'danger',
            dialogCancelButtonColor,
            onClick,
            skipDialog = false,
            confirmButtonText = <Trans>Remove</Trans>,
            cancelButtonText = <Trans>Cancel</Trans>,
            ...buttonProps
        },
        ref
    ) => {
        const [showDialog, setShowDialog] = useState(false);

        const handleClick = (e) => {
            if (skipDialog) {
                onConfirm();
            } else {
                setShowDialog(true);
                triggerHandler(onClick, e);
            }
        };

        const handleDialogClose = () => {
            setShowDialog(false);
        };

        return (
            <React.Fragment>
                <Button {...buttonProps} onClick={handleClick} ref={ref} />
                <YesNoDialog
                    title={dialogTitle}
                    body={dialogBody}
                    show={showDialog}
                    onAccept={onConfirm}
                    onClose={handleDialogClose}
                    confirmButtonColor={dialogConfirmButtonColor}
                    cancelButtonColor={dialogCancelButtonColor}
                    confirmButtonText={confirmButtonText}
                    cancelButtonText={cancelButtonText}
                />
            </React.Fragment>
        );
    }
);

export default ConfirmRemoveButton;
